import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {Collapse} from "antd";
import FooterCollapseData from "./FooterCollapseData"

const Footer = () => {
  return (
    <footer className="aa-ph-container bg-[#000] py-[70px] sm:pt-[100px] sm:pb-[150px] px-4 sm:px-2 lg:px-0">
        <h2 className="text-[#fff] text-center font-medium text-[32px] sm:text-[60px] md:text-[90px] lg:text-[120px] leading-[38px] sm:leading-[70px] md:leading-[100px] lg:leading-[120px]">
            AA Photo Booth 360
        </h2>
        <div className="mx-auto w-full sm:max-w-[1140px] pt-[50px] flex flex-col sm:flex-row gap-6 sm:gap-0 items-start">
        <div className="w-full sm:w-1/2 pr-0 sm:pr-[80px]">
            <h4 className="text-[#fff] text-[16px] leading-[24px] font-poppins-bold w-full sm:w-[60%]">
                2024 AA Photo Booth 360 LLC. All Rights Reserved.
            </h4>
        </div>
        <div className="w-full sm:w-1/2 footer-collapse">
            <Collapse
                bordered={false}
                expandIcon={({ isActive }) => ( <> { isActive ? <MinusOutlined style={{color: '#fff'}} /> : <PlusOutlined style={{color: '#fff'}} /> } </>)}
                expandIconPosition="end"
                items={FooterCollapseData}
            />
        </div>
        </div>
    </footer>
  )
}

export default Footer